/** AUTO GENERATED FROM "node ./src/utils/convert-icons.js". DO NOT TOUCH. **/
import React from 'react'
import classNames from 'classnames'


class Icon extends React.PureComponent {
  render () {
    const { className, svgRef, ...otherProps } = this.props
    return (
      <svg width="181px" height="181px" viewBox="0 0 181 181" version="1.1" fill="currentColor" className={classNames('nmx-icon', className)} ref={svgRef} {...otherProps}>
    <path d="M179.47,90.6A88.87,88.87,0,1,1,90.6,1.73,88.87,88.87,0,0,1,179.47,90.6Z" transform="translate(-0.23 -0.23)" style={{fill: "none",stroke: "#0e497b",strokeWidth: "3px",strokeDasharray: "6.059999942779541,6.059999942779541"}} fill="#fff"/><path d="M88.89,85.51a22.19,22.19,0,1,1,21.93-22.19A22.09,22.09,0,0,1,88.89,85.51Zm0-38.93A16.88,16.88,0,1,0,105.5,63.45,16.76,16.76,0,0,0,88.89,46.58Zm15.82,84.5a2.67,2.67,0,0,0-2.66-2.66H58.45V110A13.33,13.33,0,0,1,71.74,96.67H106A13.24,13.24,0,0,1,119.33,110v1.2a2.66,2.66,0,1,0,5.31,0V110A18.56,18.56,0,0,0,106,91.35H71.74A18.66,18.66,0,0,0,53.13,110v21.13a2.66,2.66,0,0,0,2.66,2.65h46.26A2.66,2.66,0,0,0,104.71,131.08Zm21.65,5L156,106.46a5.43,5.43,0,0,0-7.69-7.68l-25.8,25.79-7.68-7.69a5.44,5.44,0,0,0-7.69,7.69l11.53,11.52a5.32,5.32,0,0,0,7.68,0Z" transform="translate(-0.23 -0.23)" style={{fill: "#f6a623",stroke: "#fff",strokeWidth: "3px"}}/>
</svg>
    )
  }
}

Icon.displayName = 'ProfileOutlineCheckmarkWithBorderIcon'

export default Icon
